import { logWithPrefix } from "@/plugins/logging";
import defaultSettings from "@/settings";
import axios from "axios";
import qs from "qs";
import store from "@/store";
import commonCode from "@/utils/commonCode";
import utils from "@/plugins/utils";
import cancelClass from "./cancelToken";
// import store from '@/store'
const log = logWithPrefix("[plugin/axios.js]");
let lastConfig = {};

const service = axios.create({
  timeout: 20 * 1000,
  baseURL: defaultSettings.axiosPrefix + "/",
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  headers: {
    "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
  },
});
service.interceptors.request.use(
  async (config) => {
    log(config.method, config.url, config, new Date());
    // do something before request is sent
    const csrf = await store.dispatch("user/getCsrfToken");
    const token = await store.dispatch("user/getToken");
    config.cancelToken = cancelClass.cancelRequest.source.token;
    if (csrf) {
      config.headers.csrfToken = csrf;
    }
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    } else if (
      ![
        "conflict",
        "login",
        "locale",
        "token",
        "wizard",
        "wizardSkip",
        "isFinish",
        "multi",
        "unauth",
        "debug",
        "resetPassword",
        "info"
      ].includes(config.url)
    ) {
      utils.routerPush("/login");
      return config;
    }
    log("content-type", config.headers["Content-Type"]);
    if (typeof config.headers["Content-Type"] === "undefined") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
    }
    if (config.headers["Content-Type"].includes("application/x-www-form-urlencoded")) {
      log("post data", config.data);
      config.data = qs.stringify(config.data);
      // To Prevent empty post
      if (config.method == "post" && config.data == "") {
        config.data = "a=a";
      }
    }
    lastConfig = config;
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  async (response) => {
    const { data, status } = response;
    // store.dispatch('user/updateLoading', false)
    if (response.headers["content-type"] == "application/download") {
      return response;
    }
    if (status === 200) {
      store.dispatch("limit/resetLimit");
      log("response", JSON.parse(JSON.stringify(data)));
      if (data.code == commonCode.STATUS_UNAUTH && lastConfig.url != "login" && lastConfig.url != "multi") {
        utils.routerReplace2("login", lastConfig.url);
      } else if (data.code == commonCode.STATUS_TIMEOUT) {
        await store.dispatch("user/timeout");
        utils.routerReplace("/login");
      } else if (data.code == commonCode.STATUS_MULTI) {
        utils.routerReplace("/multi");
      } else if (data.code == commonCode.STATUS_MULTI_GUEST) {
        utils.routerReplace("/multiGuest");
      } else if (data.code == commonCode.STATUS_RESET) {
        utils.routerReplace("/unauth");
      } else if (data.code == commonCode.STATUS_FORCE) {
        utils.routerReplace("/force_change_password.html");
      } else if (data.code == commonCode.STATUS_WIZARD
        && !window.location.href.includes("routerFunc")
        && !window.location.href.includes("routerDiagram")
        && !window.location.href.includes("apDiagram")
        && !window.location.href.includes("modeLearn")
        && !window.location.href.includes("orbiUpgradeVersionDetail")) {
        const domain = window.location.hostname;
        if (!utils.checkIp(domain) && defaultSettings.type == "orbi" && !domain.includes("orbilogin") && !domain.includes("routerlogin")) {
          const protocol = window.location.protocol;
          window.location.href = protocol + "//orbilogin.com/wizard";
          return null;
        } else if (!utils.checkIp(domain) && defaultSettings.type != "orbi" && !domain.includes("routerlogin")) {
          const protocol = window.location.protocol;
          window.location.href = protocol + "//www.routerlogin.com/wizard";
          return null;
        } else {
          utils.routerReplace("/wizard");
        }
      } else if (data.code == commonCode.STATUS_TRAFFIC_LIMIT) {
        utils.routerReplace("/limit");
        store.dispatch("limit/setLimitInfo", data.data);
      } else if (data.code == commonCode.STATUS_CONFLICT) {
        utils.routerReplace("/conflict");
        store.dispatch("conflict/setInfo", data.data);
      }
      return data;
    }
    return Promise.reject(new Error(data.msg || "Error"));
  },
  (error) => {
    log("err: " + error); // for debugrn
    if (error && error.toString().includes(401)) {
      utils.routerReplace("/login");
      return { code: commonCode.STATUS_UNAUTH };
    }
    if (error && error.toString().includes(400)) {
      return { code: commonCode.STATUS_OK };
    }
    log("lastConfig", lastConfig);
    if (error && error.toString().includes(500)) {
      if (lastConfig.url == "token" && lastConfig.data == "method=wizard") {
        return {
          code: 0,
          data: {
            img_write_status: "100%",
            msg: error.toString(),
          },
        };
      }
    }
    if (lastConfig.url == "isFinish") {
      // For LAN Setup
      return null;
    } else if (
      (lastConfig.url == "wizard" || lastConfig.url == "wizardSkip") &&
      lastConfig.headers["Content-Type"].includes("form-data")
    ) {
      return {
        code: 0,
        data: {
          code: 100,
          reboot_time: commonCode.MAX_REBOOT_TIME,
        },
      };
    } else if (lastConfig.url == "logs" && lastConfig.data == "action=send_logs") {
      return {
        code: 0
      };
    } else if (error && (error.toString().includes("Network Error") || error.toString().includes("timeout"))
      && (lastConfig.url != "/info" && lastConfig.url != "orbiUpgrade" && lastConfig.url != "token")
    ) {
      console.log("lastConfig.url=", lastConfig.url);
      window.location.reload();
    } else {
      return null;
    }
  },
);

export const http = service;
